import React from 'react';
import OneMoment from 'components/App/OneMoment';

export default function PlaceholderLayout() {
    return <OneMoment/>;
}